import React from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import {openModal} from '../../../../../actions/ui/modals';
import moment from 'moment'
import cn from 'classnames'
import './styles.css'

const DateSetter = ({ openModal, setTrackedDays, untilDate, setUntilDate }) => {

  const isToday = moment().diff(moment(untilDate), 'days') === 0

  const step = (days) => {
    const momDay = moment(untilDate).add(days, 'days')
    const smartDay = momDay.format('YYYYMMDD')
    setUntilDate(smartDay);
  }

  const stepBack = () => step(-1)
  const stepForward = () => !isToday && step(1)

  const dateString = moment(untilDate).format('MM/DD/YYYY')

  return (
    <fb className="date-panel">
      <fb className="arrow-left icon dateBtn icon-navigate_before" onClick={stepBack}></fb>
      <fb className="calendar dateBtn dateDisplay" onClick={()=>openModal('UNTIL_DATE_PICKER')}>{ dateString }</fb>
      <fb className={cn({'arrow-right': 1, icon: 1, 'icon-navigate_next': 1, dateBtn: 1, disabled: isToday})} onClick={stepForward}></fb>
    </fb>
  )
}

const actionsToProps = {
  openModal,
  setTrackedDays: (days) => ({ type: 'SET_TRACKED_DAYS', payload: days }),
  setUntilDate: (smartDate)=>({ type: 'SET_UNTIL_DATE', payload: smartDate })
}

const mapStateToProps = (state) => ({
  untilDate: state.ui.untilDate
})

const connector: Connector<{}, Props> = connect(mapStateToProps, actionsToProps)
export default connector(DateSetter)



// WEBPACK FOOTER //
// ./src/containers/app/main/chartView/dateSetter/index.js